export default __webpack_public_path__ + "static/media/Slide_LifeBridge_Register-01.df98db58.png";